import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "@/i18n/I18nContext";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { RequireAuth } from "@/components/RequireAuth";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import WalletPage from "@/pages/WalletPage";
import LobbyPage from "@/pages/LobbyPage";
import ProfilePage from "@/pages/ProfilePage";
import LegalPage from "@/pages/LegalPage";
import QueuePage from "@/pages/QueuePage";
import GamePage from "@/pages/GamePage";
import { RealtimeProvider } from "@/lib/realtime";
import VerifyPage from "@/pages/VerifyPage";
import HistoryPage from "@/pages/HistoryPage";
import LeaderboardPage from "@/pages/LeaderboardPage";
import ResponsiblePage from "@/pages/ResponsiblePage";
import DemoPage from "@/pages/DemoPage";
import ChangePasswordPage from "@/pages/ChangePasswordPage";
import LudoQueuePage from "@/pages/LudoQueuePage";
import LudoGamePage from "@/pages/LudoGamePage";
import LudoVerifyPage from "@/pages/LudoVerifyPage";
import DamesPracticePage from "@/pages/DamesPracticePage";
import LudoPracticePage from "@/pages/LudoPracticePage";
import DicePracticePage from "@/pages/DicePracticePage";
import DamesGamePage from "@/pages/DamesGamePage";
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import { Admins, Announcements, Audit, ChatReports, DamesGames, Dashboard, Finance, GameDetail, Games, LudoGames, PlayerDetail, Players, ReferralAdmin, Settings } from "@/admin/AdminPages";
import ReferralRulesPage from "@/pages/ReferralRulesPage";
import MessagesPage from "@/pages/MessagesPage";

const refParam = new URLSearchParams(window.location.search).get("ref");
if (refParam && /^[A-Za-z0-9]{4,12}$/.test(refParam)) localStorage.setItem("bkm_ref", refParam.toUpperCase());

const guard = (el) => <RequireAuth>{el}</RequireAuth>;

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <RealtimeProvider>
          <BrowserRouter>
            <Routes>
              <Route path="admin/login" element={<AdminLogin />} />
              <Route path="admin" element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="players" element={<Players />} />
                <Route path="players/:id" element={<PlayerDetail />} />
                <Route path="kyc" element={<Players kycOnly />} />
                <Route path="games" element={<Games />} />
                <Route path="games/:id" element={<GameDetail />} />
                <Route path="finance" element={<Finance />} />
                <Route path="settings" element={<Settings />} />
                <Route path="chat" element={<ChatReports />} />
                <Route path="referral" element={<ReferralAdmin />} />
                <Route path="announcements" element={<Announcements />} />
                <Route path="audit" element={<Audit />} />
                <Route path="admins" element={<Admins />} />
                <Route path="ludo" element={<LudoGames />} />
                <Route path="dames" element={<DamesGames />} />
              </Route>
              <Route element={<Layout />}>
                <Route index element={<Landing />} />
                <Route path="auth" element={<AuthPage />} />
                <Route path="lobby" element={guard(<LobbyPage />)} />
                <Route path="queue" element={guard(<QueuePage />)} />
                <Route path="game/:id" element={guard(<GamePage />)} />
                <Route path="demo" element={<DemoPage />} />
                <Route path="wallet" element={guard(<WalletPage />)} />
                <Route path="change-password" element={guard(<ChangePasswordPage />)} />
                <Route path="ludo/queue" element={guard(<LudoQueuePage />)} />
                <Route path="ludo/game/:id" element={guard(<LudoGamePage />)} />
                <Route path="ludo/verify/:id" element={<LudoVerifyPage />} />
                <Route path="dames/essai" element={<DamesPracticePage />} />
                <Route path="ludo/essai" element={guard(<LudoPracticePage />)} />
                <Route path="des/essai" element={guard(<DicePracticePage />)} />
                <Route path="dames/game/:id" element={guard(<DamesGamePage />)} />
                <Route path="profile" element={guard(<ProfilePage />)} />
                <Route path="legal/:page" element={<LegalPage />} />
                <Route path="verify" element={<VerifyPage />} />
                <Route path="history" element={guard(<HistoryPage />)} />
                <Route path="leaderboard" element={<LeaderboardPage />} />
                <Route path="parrainage" element={<ReferralRulesPage />} />
                <Route path="messages" element={guard(<MessagesPage />)} />
                <Route path="account" element={guard(<ResponsiblePage />)} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster theme="dark" position="top-center" richColors />
          </RealtimeProvider>
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
